import React from 'react';

//
class ItemMenu extends React.Component{
  constructor (props){
    super(props);
  }

  render() {
    const { dados } = this.props;
    let classes = dados.classes+' menu-relatorios__link js-relatorio-bt ';

    if(dados.main){
      classes += ' menu-relatorios__link--main ';
    }

    return (
      <a href='#'  className={classes} onClick={(e) => this.props.clickHandler(dados, e)}>
        <span className='menu-relatorios__txt'>{dados.title}</span>
        <span className='menu-relatorios__arrow'><i className='fas fa-chevron-right'></i></span>
      </a>
    );
  }
}

export default ItemMenu;



// WEBPACK FOOTER //
// ./src/classes/relatorios/ItemMenu.js